import React from 'react';
import { Text, i18n, tokens } from '@simplybenefits/sb-ui-library';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import { helpers } from '@simplybenefits/sb-utils';

/**
 * 
 * @param {*} std 
 * @returns 
 */
const createGradedSTDCoverage = (std) => {
    let stdStr = i18n.t(tokens.labels.coverage.gradedScaleFirstPart, { percentageFirstMax: std.percentageFirstMax, firstMax: helpers.numberWithCommas(std.firstMax) });

    if (std.percentageSecondMax && std.secondMax === 0) {
        stdStr += i18n.t(tokens.labels.coverage.gradedScaleSecondPart, { percentageSecondMax: std.percentageSecondMax });
        return stdStr;
    }

    if (std.percentageSecondMax && std.secondMax > 0) {
        stdStr += i18n.t(tokens.labels.coverage.gradedScaleThirdPart, { percentageSecondMax: std.percentageSecondMax, secondMax: std.secondMax });
    }

    if (std.percentageThirdMax) {
        const thirdMaxType = std.thirdMax > 0 ? i18n.t(tokens.labels.coverage.ofTheNext) : i18n.t(tokens.labels.coverage.theRemainder);
        const thirdMax = std.thirdMax ? helpers.numberWithCommas(std.thirdMax) : '';
        stdStr += i18n.t(tokens.labels.coverage.gradedScaleFourthPart, { percentageThirdMax: std.percentageThirdMax, thirdMaxType, thirdMax });
        return stdStr;
    }

    return stdStr;
};

/**
 *
 * @param {*} props
 */
export default function Std({ classes, expanded, std, handleChange, isStudent }) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('std')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('std') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>{ i18n.t(tokens.titles.shortTermDisability) }</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        std.isEligible !== 1 ? 
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    { i18n.t(tokens.labels.coverage.ineligibleForBenefit)}
                                </Text>
                            </div>
                            : 
                            null
                    } 

                    {
                        std.isGraded ?
                            <>
                                <Text small bold margin="20px 0px 0px 0px">{createGradedSTDCoverage(std)}</Text>
                                <Text small bold margin="0px 0px 20px 0px">{ std.isTaxable ? i18n.t(tokens.labels.coverage.taxable) : i18n.t(tokens.labels.coverage.nonTaxable) }</Text>
                            </>
                            :
                            <>
                                <Text small bold margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.flatAmountCoverage, { percentageOfFlatAmount: std.percentageOfFlatAmount }) }</Text>
                                <Text small bold margin="0px 0px 20px 0px">{ std.isTaxable ? i18n.t(tokens.labels.coverage.taxable) : i18n.t(tokens.labels.coverage.nonTaxable) }</Text>
                            </>
                    }

                    <div>
                        { 
                            std.maxEvidence > 0 ? 
                                <Text small margin="5px 0px 0px 0px">
                                    { i18n.t(tokens.labels.coverage.maxEvidenceLabel, { maxEvidence: helpers.numberWithCommas(std.maxEvidence) }) }
                                </Text>
                                :
                                null 
                        }

                        {
                            std.maxNoEvidence > 0 ? 
                                <Text small margin="5px 0px 0px 0px">
                                    { i18n.t(tokens.labels.coverage.maxNoEvidenceLabel, { maxNoEvidence: helpers.numberWithCommas(std.maxNoEvidence) }) }
                                </Text>
                                :
                                null
                        }

                        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.elimPeriodAccident, { elimPeriodAccident: std.elimPeriodAccident })}</Text>
                        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.elimPeriodHospital, { elimPeriodHospital: std.elimPeriodHospital }) }</Text>
                        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.elimPeriodSickness, { elimPeriodSickness: std.elimPeriodSickness })}</Text>
                        <Text small margin="5px 0px 0px 0px">{ std.defOfDisability ? std.defOfDisability : null }</Text>
                        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.benefitsPeriodWeek, { benefitsPeriod: std.benefitsPeriod }) }</Text>
                        {isStudent ?
                            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.terminatesAtEndOfStudy, { terminationAge: std.terminationAge }) }</Text>
                            :
                            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.terminatesAtAge, { terminationAge: std.terminationAge }) }</Text>
                        }
                    </div>

                </AccordionDetails>
            </Accordion>
        </div>
    );
}